import classNames from 'classnames'
import { Link } from 'react-router-dom'

import { MOBILE_WIDTH_BREAKPOINT } from '~/lib/constants'
import { useMediaQuery } from '~/hooks/useMediaQuery'
import { IconButton } from '~/components/IconButton'
import CrossIcon from '~/assets/icons/cross.svg'

import ArrowIcon from './assets/arrow.svg'
import QuestionIcon from './assets/question.svg'

import styles from './PageHeader.pcss'

interface Props {
	backLink?: string
	className?: string
	title: string
	onQuestionClick?: () => void
	rightLink?: React.ReactNode
}

export function PageHeader({
	className,
	backLink,
	title,
	onQuestionClick,
	rightLink,
}: Props) {
	const isMobile = useMediaQuery(`(max-width: ${MOBILE_WIDTH_BREAKPOINT}px)`)

	let rightContent
	if (rightLink) {
		rightContent = rightLink
	} else if (backLink && isMobile) {
		rightContent = (
			<IconButton className={styles.crossButton} asChild>
				<Link to={backLink}>
					<CrossIcon />
				</Link>
			</IconButton>
		)
	}

	return (
		<div className={classNames(styles.container, className)}>
			{!isMobile && !!backLink && (
				<IconButton className={styles.arrowButton} asChild>
					<Link to={backLink}>
						<ArrowIcon />
					</Link>
				</IconButton>
			)}

			<h2
				className={classNames(
					styles.content,
					!rightContent && styles.withoutRight
				)}
			>
				<span className={styles.title}>{title}</span>
				{!!onQuestionClick && (
					<IconButton
						className={styles.question}
						onClick={onQuestionClick}
					>
						<QuestionIcon />
					</IconButton>
				)}
			</h2>

			<div className={styles.rightContent}>{rightContent}</div>
		</div>
	)
}
